import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { logout } from "./Utility";
import toast from 'react-hot-toast';
import customFetch from './apicall/api';

const AadhaarValidationExport = () => {
    const history = useHistory();
    const location = useLocation();
    const { api_token } = (location && location.state) || {};
    
    const [selectedDate, setSelectedDate] = useState('');
    const [loading, setLoading] = useState(false);

    const downloadReport = () => {
        if (!selectedDate) {
            toast.error('Please select a date');
            return;
        }

        setLoading(true);

        const requestOptions = {
            method: 'GET',
            headers: {},
        };

        customFetch(
            `${process.env.REACT_APP_DOWNLOAD}partner/OnGrid/aadhaar_validation.php?Date=${selectedDate}`,
            requestOptions
        )
            .then((res) => {
                // Check response status
                if (!res.ok) {
                    toast.error(`Error ${res.status}: Unable to download report. Please try again.`);
                    setLoading(false);
                    return null;
                }
                
                // For file downloads, just proceed to blob without strict content-type check
                return res.blob();
            })
            .then((blob) => {
                if (blob) {
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", `Aadhaar_Validation_${selectedDate}.xls`);
                    document.body.appendChild(link);
                    // Start download
                    link.click();
                    // Clean up and remove the link
                    link.parentNode.removeChild(link);
                    window.URL.revokeObjectURL(url);
                    
                    toast.success('Report downloaded successfully');
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log("error", error);
                toast.error('Failed to download report. Please try again.');
                setLoading(false);
            });
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            downloadReport();
        }
    };

    return (
        <div className="container">
            <div className="utr_navbar">
                <button className='button back_button' onClick={() => history.goBack()}>
                    <img
                        src={require("../assets/images/back.png")}
                    />
                </button>
                <h3>Aadhaar Validation Export</h3>
                <button className='button' onClick={logout}>
                    <img
                        src={require("../assets/images/power-off.png")}
                        alt=""
                    />
                </button>
            </div>

            <div className="mt-4 d-flex justify-content-center">
                <div className="row" style={{ width: '100%', maxWidth: '800px' }}>
                    <div className="col-12 col-md-6 mb-3 mb-md-0">
                        <label htmlFor="selectedDate" style={{ fontWeight: 'bold' }}>
                            Select Date
                        </label>
                        <input
                            id="selectedDate"
                            type="date"
                            className="form-control"
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                            onKeyPress={handleKeyPress}
                            disabled={loading}
                            max={new Date().toISOString().split('T')[0]}
                        />
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-end">
                        <button
                            className="btn btn-primary w-100"
                            onClick={downloadReport}
                            disabled={loading || !selectedDate}
                        >
                            {loading && (
                                <span
                                    className="spinner-border spinner-border-sm mr-2"
                                    role="status"
                                    aria-hidden="true"
                                />
                            )}
                            {loading ? 'Downloading...' : 'Download Report (XLS)'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AadhaarValidationExport;
